import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../ui_kit/button/Button';
import ga4DataLayer from '../../../services/ga4_datalayer';
import facebookPixel from '../../../services/facebook_pixel';

function Preorder(props) {
  const trackAddToBag = (eventId) => {
    const {
      productId, price, discount = 0, variant, name, sku,
    } = props;

    const product = {
      sku, variant, name, price,
    };

    facebookPixel.trackAddToBag(productId, price, eventId);
    // GA4 expects the unit price the user actually pays — subtract the
    // discount the variant serializer reports separately.
    ga4DataLayer.trackAddToCart({ ...product, price: price - discount });
  };

  const addToBag = () => {
    const { addToBagClickHandler } = props;

    const eventId = facebookPixel.generateEventId();

    trackAddToBag(eventId);

    addToBagClickHandler(eventId);
  };

  const {
    buttonColor = 'blue', loading, className, text = 'PRE-ORDER',
  } = props;

  return (
    <Button
      text={text}
      size="small"
      color={buttonColor}
      className={className}
      loading={loading}
      onClickHandler={addToBag}
    />
  );
}

Preorder.propTypes = {
  price: PropTypes.number.isRequired,
  discount: PropTypes.number,
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  sku: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  buttonColor: PropTypes.oneOf([
    'black', 'white', 'blue', 'transparent-blue', 'yellow', 'green', 'transparent-green',
  ]),
  addToBagClickHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

export default Preorder;
